import React, { useCallback, useEffect, useMemo } from 'react'
import { TitleBar, Container, Button, Menu, MenuItem } from '@sencha/ext-modern'
import { Transition } from '@sencha/ext-react-transition'

import { cleanLoginToken, setLoginToken } from 'tyan/public'
import ErrorBoundary from 'tyan/public/components/ErrorBoundary'
import Message from 'tyan/public/components/Message'
import Form from 'tyan/public/components/Form'
import FormMessage from 'tyan/public/components/FormMessage'
import { useInstData } from 'tyan/public/hooks'
import * as linkApprovalForms from 'tyan/pubConfig/linkApprovalForms'

const Wrapper = props => {
	const { me: { compID } } = useInstData(props, useMemo(() => ({ compID: `linkapprovalwrapper-${Tyan.getUuid()}` }), []))
	const {
		children, systemName, companyName, title = '',
		loginInfo: { subOrg = '', depName = '', userName = '', token, authType }
	} = props

	return <Container id={compID} layout={{ type: 'hbox', /* align: 'center',  */pack: 'center' }} cls="main-background">
		<Container layout="fit" flex={4} >
			<TitleBar noLocale docked="top" shadow style={{ zIndex: 2 }}
				title={`　${systemName}${Tyan.appSettings['test'] && ' (测试)' || ''}${title ? `　　　${title}` : ''}`}
			>
				{/* {showMenu && <Button key='menu' align="left" iconCls="x-fa fa-bars" handler={handleShowTree} />} */}
				{/* 					<Button align="left" iconCls="x-fa fa-bars" handler={handleToggleTree} hidden={!showMenu} />*/}
				{
					Ext.os.is.Phone
						? <div></div>
						: <Container align="right">
							<div style={{ fontSize: '15px', color: '#bfdafb' }}>
								{`${Tyan.t(subOrg) || ''}${Tyan.t(companyName) || ''}${(subOrg || companyName) && depName ? '（' : ''
									}${depName || ''}${(subOrg || companyName) && depName ? '）' : ''}`}
							</div>
						</Container>}
				<Button align="right" iconCls="x-fa fa-user" noLocale={true} text={`${userName}${authType === 'auth' ? '（代）' : ''}`} arrow={true} hidden={!token} />
				{/*!['public'].includes(Tyan.sysMode) &&
				<>
					<Button align="right" iconCls="x-fa fa-user" noLocale={true} text={`${userName}${authType === 'auth' ? '（代）' : ''}`} arrow={true} hidden={!token}>
						<Menu>
							{
								Tyan && Tyan.restoreMockDb &&
								<MenuItem text={Tyan.t("恢复mockData", 'menuItem')} iconCls="x-fa fa-reply"
									onClick={() => { Tyan.restoreMockDb(); window.location.reload(true) }}
								/> || null
							}
							<MenuItem text={Tyan.t("修改密码", 'menuItem')} iconCls="x-fa fa-key" onClick={() => history.push('/ChangePassword')} />
							<MenuItem text={Tyan.t("注销", 'menuItem')} iconCls="x-fa fa-sign-out" onClick={() => history.push('/Logout')} />
							<AppLogin appLogins={appLogins} />
							<Agent />
						</Menu>
					</Button>
					<Button align="right" iconCls="x-fa fa-user" text='登录' handler={() => history.push('/Login')} hidden={token} />
				</> || null
			}
*/}
			</TitleBar>
			<Container layout="fit" flex={1}>
				<Transition type="slide" bindDirectionToLocation padding="10">
					<Container id={`container-${compID}`} layout={{ type: 'vbox', pack: 'center', align: 'center' }}>
						<Container id={`inner-${compID}`} flex={1} layout='fit' margin="5 0 0 0" scrollable autoSize={true} {...Tyan.mainPageProps} maxWidth='100%'>
							<ErrorBoundary>
								{children}
							</ErrorBoundary>
						</Container>
					</Container>
				</Transition>
			</Container>
		</Container>
	</Container >
}

const LinkApproval = props => {
	const { setState, me: {
		state: {
			errorMessage, form, para, title, loginInfo, done
		}
	} } = useInstData(props, useMemo(() => {
		return { state: { loginInfo: {} } }
	}, []))
	let { systemName, companyName, location: { search } } = props
	search = search.substring(1)

	const Comp = linkApprovalForms[form]

	useEffect(() => { return () => { cleanLoginToken() } }, [])

	useEffect(() => {
		search
			? Tyan.doPostEvent('GetLinkInfo', {
				data: { linkToken: search },
				onEnd: ({ errorMessage, title, loginInfo = {}, loginInfo: { token } = {}, form, para }) => {
					errorMessage
						? setState({ errorMessage })
						: (!form || !linkApprovalForms[form])
							? setState({ errorMessage: `${form} 无相关配置，请与系统管理员联系` })
							: (setLoginToken(token), setState({ form, para, title, loginInfo }))
				}
			})
			: setState({ errorMessage: '无效链接' })
	}, [search])

	useEffect(() => {
		errorMessage && Tyan.pubForm.showError(errorMessage, () => setTimeout(window.close))
	}, [errorMessage])

	useEffect(() => {
		done && setTimeout(window.close)
	}, [done])

	const handleClose = useCallback(() => {
		cleanLoginToken()
		setState({ done: true })
		// setTimeout(window.close)
	}, [])

	return <Wrapper {...{ systemName, companyName, title, loginInfo }}>
		{
			done
				? false && <Container layout={{ type: 'vbox', pack: 'start' }}>
					<Button text='关闭' shadow ui='action' iconCls='x-fa fa-close' handler={() => setTimeout(window.close)} />
				</Container> || null
				: Comp
					? <Comp {...para} showBody={Form} showMessage={FormMessage} onClose={handleClose} />
					: errorMessage
						? null
						: <Message text='请稍等 ...' />
		}
	</Wrapper>
}

export default LinkApproval